import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { environment } from 'environments/environment';
import { UsersService } from './users.service';
import { ConfigService } from './config.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'ICICI-MarketingPages';
  counter: number = 0;
  domainProperty :any = {};

  constructor(private config: ConfigService, private userService: UsersService) {}

  async ngOnInit(): Promise<void> {
    await this.loadConfigData();

    while (environment.Base_url === '' && this.counter < 3) {
      this.counter++;
      await this.loadConfigData();
    }    

   
    console.log('Domain Property ngOnInit:', this.domainProperty);
  }

  private async loadConfigData(): Promise<void> {
    const configData = await this.config.jsonConfigData();
    // Handle config data if necessary
  }
}
